// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dMMQ","left":"styles_left__3tV3W","desktopActions":"styles_desktopActions__c2X6K","title":"styles_title__v4Ffb"};